import { User } from "../../shared/models/user.model";

export class UnitTreeNode {
  label: string;
  children: UnitTreeNode[];
  leaf: boolean = false;
  id: number = 0;
  parent: UnitTreeNode;
  selectable: boolean = true;
  UnitId: number = 0;
  UnitTypeId: number = 0;
  UnitTypeName: string = '';
  UnitName: string = '';
  CompanyId: number = 0;
  CompanyName: string = '';
  ContactList: ContactList[] = [];
  ContractDetails: ContractDetails[] = [];
  ParentId: number = 0;
  CreatedBy: number;
  ModifiedBy: number;
  IsActive: boolean = true;
  expanded: boolean = false;
  ShowUnitNameErrorMessage: boolean = false;
  ShowUnitTypeErrorMessage: boolean = false;
  ShowCompanyNameErrorMessage: boolean = false;
}
export class ContactList {
  UnitContactInfoId: number = 0;
  PersonName: string = '';
  EmailId: string = '';
  PhoneNumber: string = '';
  Designation: string = '';
  ShowPersonNameErrorMessage: boolean = false;
  ShowEmailIdErrorMessage: boolean = false;
  ShowPhoneNumberErrorMessage: boolean = false;
  ShowDesignationErrorMessage: boolean = false;
}
export class ContractDetails {
  UnitContractDetailsId: number = 0;
  ContractNumber: string = '';
  ContractHolderName: User = new User();
  ContractHolderId: number;
  ShowContractNumberErrorMessage: boolean = false;
  ShowContractHolderNameErrorMessage: boolean = false;
  IsDelete: boolean = false;
}
